<template>
<div class="chapter">
<div class="inner_page">
<div class="titlepage">
<p class="center"><span class="big"><big>EDNA<br/><br/>BUCHANAN</big></span></p>
<h1 class="chapter2"><span class="big"><big>PULSE</big></span></h1>
<p class="figure1"><img alt="" src="OEBPS/images/9780061957710_L01.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780061957710_epub_tp_r1.vue?e3c1f46a